import Vue from "vue";
import Router from "vue-router";
import Orders from "./ui/pages/Orders.vue";
import Login from "./ui/pages/Login.vue";
import Banners from "./ui/pages/Banners.vue";
import firebase from "firebase";
import Companies from "./ui/pages/Companies.vue";
import Providers from "./ui/pages/Providers.vue";
import Configuration from "./ui/pages/Configuration.vue";
import Coupons from "./ui/pages/Coupons.vue";
import OrdersReport from "./ui/pages/OrdersReport.vue";
import ReportAdmin from "./ui/pages/ReportAdmin.vue";
import Report from "./ui/pages/ReportComerce.vue";
import Users from "./ui/pages/Users.vue";
import ProvinceZones from "./ui/pages/ProvinceZones.vue";
import AdminUsers from "./ui/pages/AdminUsers";
import LoPrimo from "./ui/pages/LoPrimo";
import DriverDetails from "./ui/pages/DriverDetails";
import CompanyProfile from "./ui/pages/CompanyProfile";
import CompanyOrders from "./ui/pages/CompanyOrders";
import BasketDetail from "./ui/pages/BasketDetail";
import CompanyDetail from "./ui/pages/CompanyDetail";
import OnBoarding from "./ui/pages/OnBoarding";
import OnBoardingForm from "./ui/pages/OnBoardingForm";
import GiftCards from "./ui/pages/GiftCards";
import ThreeDSecure from "./ui/pages/ThreeDSecure.vue";
import ThreeDSecurePalla from "./ui/pages/ThreeDSecurePalla.vue";
import ServicesPage from "./ui/pages/ServicesPage.vue";
import ServiceDetail from "./ui/pages/ServiceDetail.vue";
import redirectPage from "./ui/pages/RedirectPagePalla.vue";
import Analytics from "./ui/pages/AnalyticsPage.vue";
import TableAnalytics from "./ui/pages/TableAnalyticsPage.vue";
import AdvertisingPage from "./ui/pages/AdvertisingPage.vue";
import AddAdvertisingPage from "./ui/pages/AddAdvertisingPage.vue";
import DetailAdvertisingPage from "./ui/pages/DetailAdvertisingPage.vue";
import DetailMediaPage from "./ui/pages/DetailMediaPage.vue";
import GiftCardApplicationPage from "./ui/pages/GiftCardApplicationPage.vue";

import { userStore } from "./store/userStore";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/onboarding/:id",
      name: "onboarding-detail",
      component: OnBoardingForm,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/onboarding",
      name: "onboarding",
      component: OnBoarding,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/giftcards",
      name: "giftcards",
      component: GiftCards,
      meta: {
        requiresAuth: true,
        requiresAdmin: false,
      },
    },

    {
      path: "/",
      name: "home",
      component: Orders,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/banners",
      name: "banners",
      component: Banners,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/reportAdmin",
      name: "orders-admin",
      component: ReportAdmin,
      meta: {
        requiresAuth: true,
        requiresAdmin: false,
      },
    },
    {
      path: "/report",
      name: "report",
      component: Report,
      meta: {
        requiresAuth: true,
        requiresAdmin: false,
      },
    },
    {
      path: "/coupons",
      name: "coupons",
      component: Coupons,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/companies",
      name: "companies",
      component: Companies,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/providers",
      name: "providers",
      component: Providers,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/configurations",
      name: "configurations",
      component: Configuration,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/app-users",
      name: "app-users",
      component: Users,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/availability-zones",
      name: "availability-zones",
      component: ProvinceZones,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/admin-users",
      name: "admin-users",
      component: AdminUsers,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/lo-primo",
      name: "lo-primo",
      component: LoPrimo,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/driver/:id",
      name: "driver-detail",
      component: DriverDetails,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/companies/:id/resources",
      name: "company-profile",
      component: CompanyProfile,
      meta: {
        requiresAdmin: false,
        requiresAuth: true,
      },
    },
    {
      path: "/companies/:id/orders",
      name: "company-orders",
      component: CompanyOrders,
      meta: {
        requiresAdmin: false,
        requiresAuth: true,
      },
    },
    {
      path: "/companies/:company_id/basket/:basket_id",
      name: "company-basket",
      component: BasketDetail,
      meta: {
        requiresAdmin: false,
        requiresAuth: true,
      },
    },
    {
      path: "/companies/:company_id",
      name: "company-detail",
      component: CompanyDetail,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/services",
      name: "services",
      component: ServicesPage,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/advertising",
      name: "advertising",
      component: AdvertisingPage,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/detailAlbum/:id",
      name: "album-detail",
      component: DetailAdvertisingPage,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/detailMedia/:id",
      name: "detail-media",
      component: DetailMediaPage,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/addAdvertising",
      name: "addAdvertising",
      component: AddAdvertisingPage,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/analytics",
      name: "analytics",
      component: Analytics,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/tableAnalytics",
      name: "tableAnalytics",
      component: TableAnalytics,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/GiftCardApplication",
      name: "GiftCardApplication",
      component: GiftCardApplicationPage,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/service/:service_id",
      name: "service-detail",
      component: ServiceDetail,
      meta: {
        requiresAdmin: true,
        requiresAuth: true,
      },
    },
    {
      path: "/inviteUser/:receiver_id",
      name: "inviteUser",
      component: redirectPage,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/threedsecure",
      name: "threed-verification",
      component: ThreeDSecure,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/threedsecurePalla",
      name: "threed-verificationPalla",
      component: ThreeDSecurePalla,
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!firebase.auth().currentUser) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      if (
        to.matched.some((record) => record.meta.requiresAdmin) &&
        !userStore.getters.isAdmin
      ) {
        next({
          path: "/orders",
          query: {
            redirect: to.fullPath,
          },
        });
      } else {
        next();
      }

      next();
    }
  } else {
    next();
  }
});

export default router;
